import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import {
  NETWORK_AVAILABLE,
} from "../../../constants";
import { renderErrorCreatePool } from "../../../utils/validate";
import useStyles from "../style";

function SolanaClaimNetwork(props: any) {
  const classes = useStyles();
  const { setValue, errors, control, poolDetail, watch } = props;
  const renderError = renderErrorCreatePool;

  useEffect(() => {
    if (poolDetail && poolDetail.network_claim) {
      setValue("networkClaim", poolDetail.network_claim);
    }
  }, [poolDetail]);
  const isDeployed = !!poolDetail?.is_deploy;
  const networkAvailable = watch("networkAvailable");

  useEffect(() => {
    setValue("networkClaim", networkAvailable);
  }, [poolDetail, networkAvailable, setValue]);

  return (
    <>
      <div className={classes.formControl} style={{display: "none"}}>
        <FormControl component="fieldset">
          <label className={classes.formControlLabel}>Token Network</label>

          <Controller
            rules={{
              required: true,
            }}
            control={control}
            defaultValue={networkAvailable || NETWORK_AVAILABLE.SOLANA}
            name="networkClaim"
            as={
              <RadioGroup row>
                <FormControlLabel
                  value={NETWORK_AVAILABLE.SOLANA}
                  control={<Radio />}
                  label="Ether"
                  disabled={isDeployed}
                />
              </RadioGroup>
            }
          />
          <p className={classes.formErrorMessage}>
            {renderError(errors, "networkClaim")}
            {renderError(errors, "networkNotMatch")}
          </p>
        </FormControl>
      </div>
    </>
  );
}

export default SolanaClaimNetwork;
